import { css } from '@flex-design-system/stitches-react';

const root = css({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5
})();
const textBase = css({
  color: "$grayDarker"
})();
const textBold = css({
  "&&": {
    fontWeight: 700
  }
})();
const textStrikethrough = css({
  textDecorationLine: "line-through",
  color: "$grayDark"
})();
const textCode = css({
  "&&": {
    color: "$magenta"
  },
  fontSize: 13,
  lineHeight: 1.5,
  background: "$blackAlpha004",
  boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
  borderRadius: 4,
  padding: "2px 4px"
})();
const textLink = css({
  display: "inline",
  "span, strong, em": {
    color: "$cosmicBlue"
  },
  "&:hover": {
    "span, strong, em": {
      color: "$cosmicBlueDark"
    },
    textDecoration: "underline",
    textDecorationColor: "$cosmicBlueLighter",
    textUnderlineOffset: 2
  }
})();
const textItalic = css({
  fontStyle: "italic"
})();
const textUnderline = css({
  textDecoration: "underline"
})();
const paragraph = css({})();
const heading1 = css({
  fontSize: 24,
  fontWeight: 600,
  lineHeight: "33px",
  color: "$grayDarker"
})();
const heading2 = css({
  fontSize: 20,
  fontWeight: 600,
  lineHeight: "28px",
  color: "$grayDarker"
})();
const heading3 = css({
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "22px",
  color: "$grayDarker"
})();
const _listBase = { padding: "0", margin: "0", marginLeft: "20px" };
const listItem = css({
  lineHeight: 1.5,
  marginLeft: -4,
  "&::marker": {
    color: "$grayDark"
  }
})();
const ol = css({
  ..._listBase
})();
const ul = css({
  ..._listBase
})();
const olDepth1 = css({ listStyleType: "decimal" })();
const olDepth2 = css({ listStyleType: "lower-alpha" })();
const olDepth3 = css({ listStyleType: "lower-roman" })();
const olDepth4 = css({ listStyleType: "lower-greek" })();
const olDepth5 = css({ listStyleType: "lower-latin" })();
const ulDepth1 = css({ listStyleType: "disc" })();
const ulDepth2 = css({ listStyleType: "circle" })();
const ulDepth3 = css({ listStyleType: "square" })();
const ulDepth4 = css({ listStyleType: "circle" })();
const ulDepth5 = css({ listStyleType: "square" })();
const nestedList = css({})();
const nestedListItem = css({
  listStyleType: "none"
})();
const WIDTH = 3;
const blockquote = css({
  position: "relative",
  lineHeight: 1.5,
  margin: 0,
  padding: 0,
  paddingLeft: 13,
  "&:before": {
    content: "",
    position: "absolute",
    left: 0,
    top: -3,
    width: WIDTH,
    height: `calc(100% + ${WIDTH * 2}px)`,
    background: "$grayLighter",
    borderRadius: WIDTH
  }
})();

export { _listBase, blockquote, heading1, heading2, heading3, listItem, nestedList, nestedListItem, ol, olDepth1, olDepth2, olDepth3, olDepth4, olDepth5, paragraph, root, textBase, textBold, textCode, textItalic, textLink, textStrikethrough, textUnderline, ul, ulDepth1, ulDepth2, ulDepth3, ulDepth4, ulDepth5 };
//# sourceMappingURL=base.mjs.map
